import { List } from "antd"
import { IProject } from "../types/project.type"
import AsinsKeywordsCount from "../ui/AsinsKeywordsCount"
import PrimaryAsin from "../ui/PrimaryAsin"
import ProjectImage from "./ProjectImage"
import useNavigateToProjectData from "../hooks/useNavigateToProjectData"

const ProjectListItem: React.FC<{ project: IProject }> = ({ project }) => {
  const primaryAsin = project.asins.find((asin) => asin.isPrimary)
  const navigateToProjectData = useNavigateToProjectData()

  return (
    <List.Item
      key={project._id}
      extra={<ProjectImage imageUrl={primaryAsin?.imageUrl || project.asins[0].imageUrl} />}
      onClick={() => navigateToProjectData(project._id)}
    >
      <List.Item.Meta
        title={project.title}
        description={<PrimaryAsin countryCode={project.countryCode} asin={primaryAsin?.asin} />}
      />
      <AsinsKeywordsCount
        asinsCount={project.asins.length}
        keywordsCount={project.keywords.length}
      />
    </List.Item>
  )
}

export default ProjectListItem
